var _path, _polygon, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.23 11.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sound") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.23,10.37,1,.1.25.8,2.81,3.36l-.24.24H0V7.43H2.57l3.27,3.31V6.39L8.68,9.23a5.21,5.21,0,0,1-1.6,1V11A5.84,5.84,0,0,0,9.24,9.79l1.29,1.29Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5.84 0.3 4.21 1.95 5.84 3.58 5.84 0.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65,5.52A2.79,2.79,0,0,0,7.08,3V4.81L8.54,6.28A2.74,2.74,0,0,0,8.65,5.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.35,5.52a4.93,4.93,0,0,1-.47,2.1l.6.6A5.78,5.78,0,0,0,7.08,0V.84A5,5,0,0,1,10.35,5.52Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound_off.1357c117f24622f15aad365ab66251b8.svg";
export { ForwardRef as ReactComponent };